import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { useSession } from '@/hooks/useSession';
import { confirm } from '@/lib/confirm';
import { t } from 'i18next';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import { ChatMessage, ChatMessageActions, ChatMessageBody, ChatMessageHeader, ChatMessageInside, ChatMessageText, ChatMessageTitle, ChatMessageWrapper } from '@/components/custom/chat';
import { Badge } from '@/components/ui/badge';
import { AvatarWrapper } from '@/components/ui/avatar';
import usePermission from '@/hooks/usePermission';
import ChatFileCard from '@/components/custom/chat/chat-file-card';

export default function CommentCard({ comment, onDelete }) {
  const { session } = useSession();

  const userId = session?.user?.id;
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });

  const handleDelete = async () => {
    const confirmed = await confirm({
      title: t('projects.warningDeleteCommentTitle'),
      confirmText: t('button.yes'),
      cancelText: t('button.no')
    });
    if (confirmed) {
      onDelete(comment.id);
    }
  };

  const renderTextWithLinks = text => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text?.split(urlRegex).map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="break-all text-primary-dark underline"
          >
            {part}
          </a>
        );
      }

      return part;
    });
  };

  return (
    comment?.user && (
      <ChatMessageWrapper>
        <ChatMessage>
          <AvatarWrapper
            src={comment?.user?.image?.url}
            text={comment?.user?.name}
          />

          <ChatMessageInside>
            <ChatMessageHeader>
              <ChatMessageTitle>{comment?.user?.name}</ChatMessageTitle>
              <Badge
                variant="bright"
                size="xs"
              >
                {comment?.user?.['profile-names'][0]}
              </Badge>
            </ChatMessageHeader>
            <ChatMessageBody>
              <ChatMessageText>{renderTextWithLinks(comment?.body)}</ChatMessageText>
              {comment?.attachments.length > 0 && comment.attachments.map(file => <ChatFileCard file={file} />)}
            </ChatMessageBody>
          </ChatMessageInside>

          {((isAdmin && usePermission('Excluir mensagens em aulas ao vivo', 'Aulas ao vivo')) || comment?.user?.id === userId) && (
            <ChatMessageActions>
              <FiTrash2
                className="w-4 cursor-pointer text-danger"
                onClick={() => handleDelete()}
              />
            </ChatMessageActions>
          )}
        </ChatMessage>
      </ChatMessageWrapper>
    )
  );
}
